$('[data-toggler]').on('click', function () {
    $('.mobile__menu').toggleClass('show')
    $('body').toggleClass('overflow')
});